import React, { useState } from "react";
import { ISelectOption } from "../../forms/util";
import './TrainEventRecordSection.css'
import { OperationalFormsPage } from "../OperationalFormsPage";
import { trainEventRecordOverview } from "./TrainEventRecordPageSelector";
import { TrainEventRecordView } from "./TrainEventRecordView";
import { TrainEventRecordCardList } from "./TrainEventRecordCardList";

interface TrainEventRecordSectionProps {
    page: ISelectOption,
    pageView: TrainEventRecordView
}

export const TrainEventRecordSection = (props: TrainEventRecordSectionProps) => {
    const [selectedPage] = useState(props.page ?? trainEventRecordOverview);
    const [pageView] = useState(props.pageView ?? TrainEventRecordView.Overview);

    const getPageTitle = () => {
        var title = selectedPage.label;
        return title;
    }

    const pageTitle = getPageTitle();

    return (
        <OperationalFormsPage key={selectedPage.value} selectedPage={selectedPage}>
            <div className="te-list-container">
                <TrainEventRecordCardList
                    view={[pageView]}
                    title={pageTitle}
                />
            </div>
        </OperationalFormsPage>
    );
};